/**
 * Ensures that the given data is an array
 */
export const asArray = <T>(data: T | T[]): T[] =>
  Array.isArray(data) ? data : [data];

/**
 * Iterates over the provided list of keys to find the first value for which the given retrievenFn has a non-null return
 * value.
 */
export const getFirstValue = <T>(
  keyArray: string[],
  retrieveFn: (key: string) => T
) => {
  let result: T | undefined;

  for (const key of keyArray) {
    result = retrieveFn(key);

    if (result != null) {
      break;
    }
  }

  return result;
};
